import React, { memo } from 'react';
var getCheckboxD = function getCheckboxD(checked) {
  return checked ? 'M13.75 2.5h-7.5A3.75 3.75 0 0 0 2.5' + ' 6.25v7.5a3.75 3.75 0 0 0 3.75 3.75h7.5a3.75 3.75 0 0 0 3.75-3.75v-7.5a3.75 3.75 ' + '0 0 0-3.75-3.75Zm-5 11.47L4.77 10l1.32-1.32 2.65 2.65 2.66-2.65 2.65-2.65 1.32 1.32-6.63' + ' 6.63h.01Z' : 'M5.833 4.167c-.92 0-1.666.746-1.666 1.666v8.334c0 .92.746 1.666 1.666' + ' 1.666h8.334c.92 0 1.666-.746 1.666-1.666V5.833c0-.92-.746-1.666-1.666-1.666H5' + '.833Zm0-1.667A3.333 3.333 0 0 0 2.5 5.833v8.334A3.333 3.333 0 0 0 5.833 17.5h8.334a3.333' + ' 3.333 0 0 0 3.333-3.333V5.833A3.333 3.333 0 0 0 14.167 2.5H5.833Z';
};
export var CheckboxIcon = /*#__PURE__*/memo(function (_ref) {
  var _ref$fill = _ref.fill,
    fill = _ref$fill === void 0 ? '#191C22' : _ref$fill,
    checked = _ref.checked;
  return /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    height: "20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: checked ? 'nonzero' : 'evenodd',
    d: getCheckboxD(checked),
    fill: fill,
    fillRule: checked ? 'nonzero' : 'evenodd'
  }));
});